import { useQuery } from "@tanstack/react-query";
import { getMediaDetail } from "#/api/mediaReference.api";
import { qk } from "#/lib/queryKeys";

export function useMediaDetail(idOrSlug: string | undefined) {
  return useQuery({
    queryKey: idOrSlug ? qk.mediaDetail(idOrSlug) : ["media", "detail", "empty"],
    queryFn: () => {
      if (!idOrSlug) {
        throw new Error("Media id or slug is required");
      }
      return getMediaDetail(idOrSlug);
    },
    enabled: Boolean(idOrSlug),
    staleTime: 15_000,
  });
}
